import Api           from '@/helpers/Api.js';
import normalize     from 'json-api-normalizer';
import qs            from 'qs';
import jsonNormalize from '@lysyi3m/json-api-normalizer';

// Import mutations
import {
    SET_MESSAGES,
    SET_MESSAGES_USERS
} from './mutation-types.js';

const resource  = '/connectors/sms/v1/messages';

// Initial state
const state = () => ({
    messages:        {},
    messagesUsers:   {},
    smsConversation: null
});

// Getters
const getters = {
    /**
     * Get messages
     *
     * @param {Object} state The state
     *
     * @return {Object}
     */
    messageList: (state) => {
        return state.messages;
    },

    /**
     * Get conversation
     *
     * @param {Object} state The state
     *
     * @return {Object}
     */
    smsConverstation: (state) => {
        return state.smsConversation;
    }
};

// Actions
const actions = {
    create: (context, { phoneNumber, sms }) => {
        return new Promise((resolve, reject) => {
            Api.post(`${resource}?include=conversation`, {
                'data': {
                    'type':       'messages',
                    'attributes': {
                        'to':      phoneNumber,
                        'content': sms
                    }
                }
            })
                .then(response => {
                    const normalizedData = normalize(response.data, { camelizeKeys: false });
                    const jsonNormalizedData = jsonNormalize(response.data, { camelizeKeys: false });

                    // Get the conversation and append message
                    const conversation = Object.values(normalizedData.conversations)[0];

                    // Initialize the messages array if empty
                    if (conversation.messages === undefined) {
                        normalizedData.conversations[conversation.id].messages = [];
                    }

                    context.commit('core/conversations/APPEND_SINGLE_CONTACT_CONVERSATIONS', normalizedData, { root: true });
                    context.commit('core/conversations/APPEND_CURRENT_CONVERSATION_WITH_NEW_MESSAGE', {
                        conversationId: conversation.id,
                        data:           jsonNormalizedData.data
                    }, { root: true });

                    resolve(normalizedData);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    /**
     * List SMS received to number
     *
     * @param   {Object}  context  The context
     * @param   {String}  phoneNumber active sms phone number
     *
     * @return  {Promise}
     */
    index: (context, payload) => {
        const urlParams = {};
        if (payload) {
            urlParams.sort    = payload.sort ? payload.sort : void 0;
            urlParams.filter  = payload.filters ? payload.filters : void 0;
            urlParams.include = payload.include ? payload.include : void 0;
        }

        return new Promise((resolve, reject) => {
            Api.get(`${resource}`, {
                params:           urlParams,
                paramsSerializer: params => qs.stringify(params, {
                    encode: false
                })
            })
                .then(response => {
                    const normalizedData = normalize(response.data, { camelizeKeys: false });
                    context.commit(SET_MESSAGES, normalizedData.messages);
                    context.commit(SET_MESSAGES_USERS, normalizedData.users);
                    resolve(normalizedData);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
};

// Mutations
const mutations = {
    [SET_MESSAGES]: (state, payload) => {
        state.messages = payload;
    },
    [SET_MESSAGES_USERS]: (state, payload) => {
        state.messagesUsers = payload;
    }
};

// Export module
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
